<div class="main-content py-2 px-0 px-lg-2">
  <div class="section-menu-items">
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['allproviders']"
      routerLinkActive="router-link-active"
    >
    <span translate class="translate">pages.newRetailer.manageProviders</span> <mat-icon class="ms-2">signal_cellular_alt</mat-icon>
    </button>
    <button
    [disabled]="isButtonDisabled"
      mat-flat-button
      class="item-each"
      [routerLink]="['addprovider']"
      routerLinkActive="router-link-active"
    >
    <span translate class="translate">pages.newRetailer.addProvider</span> <mat-icon class="ms-2">library_add</mat-icon>
    </button>
    <button
    [disabled]="isButtonDisabled"
      mat-flat-button
      [matMenuTriggerFor]="menu"
      class="item-each"
      aria-label="Manage pricelist menu holder"
      routerLinkActive="router-link-active"
      [ngClass]="{'router-link-active': retailerActive.isActive || salesActive.isActive }"
    >
    <span translate class="translate">pages.newRetailer.managePricelist</span> <mat-icon class="ms-2">assignment</mat-icon>
    </button>
    <mat-menu #menu="matMenu" panelClass="dd-menu">
      <button
        mat-menu-item
        [routerLink]="['retailer/pricelist']"
        routerLinkActive="bg-lighter"
        #retailerActive="routerLinkActive"
      >
        <mat-icon class="color">assignment_ind</mat-icon>
        <span translate class="translate">pages.newRetailer.retailerPricelist</span>
      </button>
      <button
      
        mat-menu-item
        [routerLink]="['consumer/pricelist']"
        routerLinkActive="bg-lighter"
        #retailerActive="routerLinkActive"
      >
        <mat-icon class="color">assignment_ind</mat-icon>
        <span translate class="translate">Consumer Pricelist</span>
      </button>
      <button
        mat-menu-item
        [routerLink]="['salesreps/pricelist']"
        routerLinkActive="bg-lighter"
        #salesActive="routerLinkActive"
      >
        <mat-icon class="color">perm_contact_calendar</mat-icon>
        <span translate class="translate">pages.newRetailer.salesRepsDistributorPricelist</span>
        
      </button>
      <button
        mat-menu-item
        [routerLink]="['update-pricelist/all-pricelists']"
        routerLinkActive="bg-lighter"
        #salesActive="routerLinkActive"
      >
        <mat-icon class="color">assignment_ind</mat-icon>
        <span translate class="translate">Update pricelists</span>
        
      </button>
      
    </mat-menu>
    <a routerLink="/features/providers/retailer/create" routerLinkActive #rceateActive="routerLinkActive" style="display: none"></a>
    <a routerLink="/features/providers/retailer/bulkupdate" routerLinkActive #rbulkupdateActive="routerLinkActive" style="display: none"></a>
    <a routerLink="/features/providers/salesreps/create" routerLinkActive #sceateActive="routerLinkActive" style="display: none"></a>
    <a routerLink="/features/providers/salesreps/bulkupdate" routerLinkActive #sbulkupdateActive="routerLinkActive" style="display: none"></a>
    <button
    [disabled]="isButtonDisabled"
    mat-flat-button
    class="item-each"
    [routerLink]="['pricelistmapping']"
    routerLinkActive="router-link-active"
  >
  <span translate class="translate">Pricelist Mapping</span> <mat-icon class="ms-2">library_add</mat-icon>
  </button>
  
  </div>

  <router-outlet></router-outlet>
</div>
